import HttpException from './HttpException';

export default class TooManyRequestsHttpException extends HttpException {
    name = 'TooManyRequestsHttpException';

    constructor(response: Response, message?: string) {
        super(response, message ?? 'Exceptions.services.http.too-many-requests');
    }
}
